export async function fetchCurrentUser() {
  try {
    const response = await fetch(
      "https://roombookingpenukonda.babafakhruddinschool.com/api/users/get-current-user.php",
      {
        method: "GET",
        credentials: "include",
      }
    );

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Failed to fetch current user", err);
    return { loggedIn: false };
  }
}
